import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const WarningIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M11.25 14.5v-5h1.5v5h-1.5ZM12.75 16h-1.5v1.5h1.5V16Z M12 1.534 23.118 20.5H.882L12 1.534ZM12 4.5 3.5 19h17L12 4.5Z" />
  </IconWrapper>
)

export default WarningIconMedium
